/**
 * Gemeinsame Hilfsfunktionen der Scroll-Engine.
 */

export const clamp = ( value, min, max ) => Math.min( Math.max( value, min ), max );

export const prefersReducedMotion = () =>
	window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

export const isEditMode = () =>
	document.body.classList.contains( 'elementor-editor-active' );

/**
 * Dispatcht ein CustomEvent und liefert false, wenn es abgebrochen wurde.
 */
export function dispatch( target, name, detail = {}, cancelable = false ) {
	return target.dispatchEvent(
		new CustomEvent( name, { bubbles: true, cancelable, detail } )
	);
}

export const easeInOutCubic = ( t ) =>
	t < 0.5 ? 4 * t * t * t : 1 - Math.pow( -2 * t + 2, 3 ) / 2;

/**
 * Animiert einen numerischen Wert über requestAnimationFrame.
 * Gibt eine Abbruchfunktion zurück.
 */
export function animateValue( { from, to, duration, onUpdate, onDone } ) {
	if ( duration <= 0 || prefersReducedMotion() ) {
		onUpdate( to );
		if ( onDone ) {
			onDone();
		}
		return () => {};
	}

	const start = performance.now();
	let raf = 0;

	const step = ( now ) => {
		const t = clamp( ( now - start ) / duration, 0, 1 );
		onUpdate( from + ( to - from ) * easeInOutCubic( t ) );

		if ( t < 1 ) {
			raf = requestAnimationFrame( step );
		} else if ( onDone ) {
			onDone();
		}
	};

	raf = requestAnimationFrame( step );

	return () => cancelAnimationFrame( raf );
}

export function debounce( fn, wait ) {
	let timer = 0;

	return ( ...args ) => {
		clearTimeout( timer );
		timer = setTimeout( () => fn( ...args ), wait );
	};
}

export function createLogger( enabled ) {
	if ( ! enabled ) {
		return () => {};
	}

	// eslint-disable-next-line no-console
	return ( ...args ) => console.log( '[SKAPIX Fullpage]', ...args );
}

/**
 * Normalisiert Wheel-Deltas (Zeilen- vs. Pixel-Modus).
 */
export function normalizeWheelDelta( event ) {
	return event.deltaMode === 1 ? event.deltaY * 40 : event.deltaY;
}

/**
 * Formatiert eine i18n-Vorlage wie "Sektion %d".
 */
export function formatLabel( template, number ) {
	return String( template || '%d' ).replace( '%d', String( number ) );
}
